import React, { FC } from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import VideoGallery from '../components/video/VideoGallery'

const Home: FC = () => {
  return (
    <Box>
      <Typography variant="h4" sx={{ fontWeight: 'bold', mb: 3 }}>
        Videos
      </Typography>
      <VideoGallery />
    </Box>
  )
}

export default Home
